ComponentRegistry.register(function ($context) {
    return $context.find('.modal')
}, function ($modal) {
    $modal.on('click', function (e) {
        e.stopPropagation();
    });

    $modal.closest('.mfp-container').on('click', function () {
				$modal.find('.modal__close').trigger('click');
		})
});

export default function () {
    $(document).on('click', '[data-modal]', function () {
        const targetModal = $(this).attr('data-modal');
        const $modal = $(`[data-target-modal="${targetModal}"]`);

        if ($modal.is('template')) {

        }

        if (!$modal.hasClass('modal--active')) {
            $modal.addClass('modal--active');
            ScrollLockUtil.lockPage();
            $(document).on('keyup', (e) => closeModal(e, $modal));
            $modal.trigger('modal_opened');
        } else {
            $modal.find('.modal__close').trigger('click');
        }
    });

    $('.modal__bg, .modal__close').on('click', function () {
        const $modal = $(this).closest('.modal');

        $modal.removeClass('modal--active');
        ScrollLockUtil.unlockPage();
        $modal.trigger('modal_closed');
        $(document).off('keyup', (e) => closeModal(e, $modal));
    });

    function closeModal(e, $modal) {
        if (e.keyCode == 27) {
            $modal.removeClass('modal--active');
            ScrollLockUtil.unlockPage();
            $modal.trigger('modal_closed');
        }
    }
}
